<template>
    <div class="cuttable-product-preview">
        <img class="cuttable-product-preview-image" :style="imageProperties" :src="imageUrl" :alt="imageAlt"/>
        <div class="cuttable-product-preview-crop" :style="cropMaskStyle"></div>
        <div class="cuttable-product-preview-crop-mask" :style="topMaskStyle"></div>
        <div class="cuttable-product-preview-crop-mask" :style="bottomMaskStyle"></div>
        <div class="cuttable-product-preview-crop-mask" :style="leftMaskStyle"></div>
        <div class="cuttable-product-preview-crop-mask" :style="rightMaskStyle"></div>
    </div>
</template>

<script>
    export default {
        name: "CuttableProductPreview",
        props: {
            imageUrl: {
                type: String,
                required: true,
            },
            imageAlt: {
                type: String,
                required: false,
            },
            imageWidth: {
                type: Number,
                required: false,
            },
            imageHeight: {
                type: Number,
                required: false,
            },
            originalImageHeight: {
                type: Number,
                required: true,
            },
            originalImageWidth: {
                type: Number,
                required: true,
            },
            cropX: {
                type: Number,
                required: true,
            },
            cropY: {
                type: Number,
                required: true,
            },
            cropWidth: {
                type: Number,
                required: true,
            },
            cropHeight: {
                type: Number,
                required: true,
            },
            responsive: {
                type: Boolean,
                required: false,
                default: true,
            }
        },
        computed: {
            /**
             * @return {{top: Number, left: Number, width: Number, height: Number}}
             */
            cropProperties() {
                const left = this.imageWidth
                    ? 0
                    : this.cropX / this.originalImageWidth * 100
                ;
                const top = this.imageHeight
                    ? 0
                    : this.cropY / this.originalImageHeight * 100
                ;
                const width = this.imageWidth
                    ? 0
                    : this.cropWidth / this.originalImageWidth * 100
                ;
                const height = this.imageHeight
                    ? 0
                    : this.cropHeight / this.originalImageHeight * 100
                ;

                return {
                    top,
                    left,
                    width,
                    height
                };
            },

            /**
             * @return {{top: string, left: string, width: string, height: string}}
             */
            cropMaskStyle() {
                const crop = this.cropProperties;

                return {
                    top: crop.top + '%',
                    left: crop.left + '%',
                    width: crop.width+ '%',
                    height: crop.height + '%',
                };
            },

            /**
             * @return {{top: string, left: string, width: string, height: string}}
             */
            topMaskStyle() {
                const crop = this.cropProperties;

                return {
                    top: '0%',
                    left: '0%',
                    width: '100%',
                    height: crop.top + '%',
                };
            },

            /**
             * @return {{top: string, left: string, width: string, height: string}}
             */
            bottomMaskStyle() {
                const crop = this.cropProperties;

                return {
                    top: (crop.top + crop.height) + '%',
                    left: '0%',
                    height: (100 - crop.top - crop.height) + '%',
                    width: '100%',
                };
            },

            /**
             * @return {{top: string, left: string, width: string, height: string}}
             */
            leftMaskStyle() {
                const crop = this.cropProperties;

                return {
                    top: crop.top + '%',
                    left: '0%',
                    width: crop.left + '%',
                    height: crop.height + '%',
                };
            },

            /**
             * @return {{top: string, left: string, width: string, height: string}}
             */
            rightMaskStyle() {
                const crop = this.cropProperties;

                return {
                    top: crop.top + '%',
                    left: (crop.left + crop.width) + '%',
                    width: (100 - crop.left - crop.width) + '%',
                    height: crop.height + '%',
                };
            },

            /**
             * @return {{width: string, maxWidth: string}|{}}
             */
            imageProperties() {
                if (this.responsive) {
                    return {
                        width: '100%',
                        maxWidth: this.originalImageWidth + 'px'
                    };
                }

                return {};
            }
        }
    }
</script>

<style scoped lang="scss">
    .cuttable-product-preview {
        position: relative;;

        .cuttable-product-preview-crop {
            position: absolute;
            border: 2px dashed #3F51B5;
        }

        .cuttable-product-preview-crop-mask {
            position: absolute;
            background: rgba(0, 0, 0, 0.7);
        }
    }
</style>